export const checkForSanity = (params: any, bypass: boolean = false) => {
  const { field, value, digitsLimit } = params

  const response = {
    valid: true,
    message: "",
    value,
  }

  if (bypass) {
    return response
  }
  
  // Trim string values to remove leading/trailing whitespace
  // Convert to string first if it's a number
  const trimmedValue = typeof value === "string" ? value.trim() : String(value || "").trim()
  
  switch (field) {
    case "role_category":
      return response
    case "resource_name":
      return stringTest(trimmedValue, true)
    case "role_title":
      return stringTest(trimmedValue)
    case "compensation_percent":
      return testForPercentage(trimmedValue)
    default:
      return testForNaturalNumbers(trimmedValue, digitsLimit)
  }
}

export const pnlValidator = (params: any) => {
  const { field, value, digitsLimit } = params
  // Trim string values to remove leading/trailing whitespace
  const trimmedValue = typeof value === "string" ? value.trim() : String(value || "").trim()
  if (field.includes("amount")) {
    return testForNaturalNumbers(trimmedValue, digitsLimit)
  }
  return testForPercentage(trimmedValue)
}

export const prepareNumber = (str: string, limit = 2) => {
  const parsed = parseFloat(str)
  if (isNaN(parsed)) return "0.00"
  return parsed.toFixed(limit)
}

export const condenseNumber = (str: string) => {
  // CRITICAL FIX: Use parseFloat instead of parseInt to preserve decimals
  const val = parseFloat(str)
  if (isNaN(val)) return 0
  // Round to 2 decimal places to avoid floating point precision errors
  return Math.round(val * 100) / 100
}

const testForNaturalNumbers = (val: string, digitsLimit?: number) => {
  // Trim the value to remove any leading/trailing whitespace
  const trimmedVal = typeof val === "string" ? val.trim() : String(val || "").trim()
  
  // Handle empty string after trimming
  if (trimmedVal === "") {
    return {
      valid: true,
      value: "0.00",
    }
  }
  
  const pattern = /^\d[.\d]*$/

  if (!trimmedVal.match(pattern)) {
    return {
      valid: false,
      message: "Only positive numbers are allowed in the field",
    }
  }
  if (digitsLimit) {
    const floatCoarsed = parseFloat(trimmedVal).toFixed(2)
    if (floatCoarsed.length > digitsLimit + 3) {
      return {
        valid: false,
        message: `Field only accepts numbers with less than or equal to ${digitsLimit} digits.`,
      }
    }
  }
  return { valid: true, value: prepareNumber(trimmedVal) }
}

const testForPercentage = (val: string) => {
  // Trim the value to remove any leading/trailing whitespace
  const trimmedVal = typeof val === "string" ? val.trim() : String(val || "").trim()

  if (trimmedVal !== "") {
    const check = testForNaturalNumbers(trimmedVal)
    const rangeCheck = parseFloat(trimmedVal)
    if (!check?.valid || rangeCheck > 100.0 || rangeCheck < 0.0) {
      return {
        valid: false,
        message: "Percentage should be a value between 0 and 100",
      }
    }
    return { valid: true, value: prepareNumber(trimmedVal, 1) }
  } else {
    return { valid: true, value: 0.0 }
  }
}

const stringTest = (value: string, required: boolean = false) => {
  if (value !== "") {
    const pattern = /^[a-zA-Z0-9]+[. a-zA-Z0-9]*$/
    if (!value?.match(pattern)) {
      return {
        valid: false,
        message:
          "Name should start with alphabets or numbers and only contain alphabets, numbers, spaces and periods",
      }
    }
  } else if (required) {
    return {
      valid: false,
      message: "Field is required",
    }
  }

  return { valid: true, value }
}
